import {
  MenuAudiencesIcon,
  MenuIntegrationsIcon,
  MenuLeadsDirectoryIcon,
  MenuMyAutomationsIcon,
  MenuMyLeadsIcon,
  MenuXRayIcon,
} from '@mm/icons';
import { SubscriptionFeatureFlag } from '@mm/state/controllers/FeatureFlags';
import { CompanyLevelFeatureFlag } from '@mm/state/model/CompanyModel';
import React from 'react';
import { ITEMS } from '../../common/constants/items';

export type SidebarMenuDefinition = {
  id: string;
  name: string;
  icon?: React.ReactNode;
  description?: string;
  url: string;
  childRoutes?: string[];
  mustBeSysAdmin: boolean;
  hideForFBCollaborators?: boolean;
  featureFlag?: CompanyLevelFeatureFlag | SubscriptionFeatureFlag;
  hideFeatureFlag?: CompanyLevelFeatureFlag | SubscriptionFeatureFlag;
};

export type SidebarTitleDefinition = {
  id: string;
  text: string;
  description?: string;
  icon?: React.ReactNode;
  menuItems: SidebarMenuDefinition[];
  url?: string;
  hideOnMobile: boolean;
  featureFlag?: CompanyLevelFeatureFlag | SubscriptionFeatureFlag;
  hideFeatureFlag?: CompanyLevelFeatureFlag | SubscriptionFeatureFlag;
  isBeta?: boolean;
};

export const SidebarMenuChatStartersMenuItem = {
  id: 'CHAT STARTERS',
  name: 'Chat Starters',
  url: '/chat-starters',
  mustBeSysAdmin: false,
};

export const ChatBotSidebarTitle = {
  id: 'CHATBOT',
  text: 'Chatbot',
  url: '/chat-starters',
  hideFeatureFlag: 'automations' as CompanyLevelFeatureFlag,
  menuItems: [
    SidebarMenuChatStartersMenuItem,
    {
      id: ITEMS.PAGES,
      name: ITEMS.PAGES,
      url: '/build',
      mustBeSysAdmin: false,
    },
    {
      id: ITEMS.QA,
      name: ITEMS.QA,
      url: '/trigger',
      mustBeSysAdmin: false,
    },
    {
      id: ITEMS.AUTOMATION_RULES,
      name: ITEMS.AUTOMATION_RULES,
      url: '/automation-rules',
      mustBeSysAdmin: false,
    },
  ],
  hideOnMobile: false,
};

export const CampaignsMenuTitle = {
  id: 'CAMPAIGNS',
  text: 'Campaigns',
  url: '/campaigns',
  hideFeatureFlag: 'automations' as CompanyLevelFeatureFlag,
  menuItems: [],
  hideOnMobile: false,
};

export const SIDEBAR_MENU: SidebarTitleDefinition[] = [
  ChatBotSidebarTitle,
  {
    id: 'LEADS-SEARCH',
    text: 'Get Leads',
    url: '/x-ray',
    hideOnMobile: false,
    featureFlag: 'mercury' as CompanyLevelFeatureFlag,
    menuItems: [
      {
        id: 'XRAY',
        name: 'X-Ray Pixel',
        description: 'Gather leads from your website traffic',
        url: '/x-ray',
        mustBeSysAdmin: false,
        icon: <MenuXRayIcon />,
      },
      {
        id: 'MERCURY',
        name: 'Consumer Directory',
        description: 'Purchase targeted consumer leads.',
        url: '/mercury',
        hideFeatureFlag: 'mercury' as CompanyLevelFeatureFlag,
        mustBeSysAdmin: false,
        icon: <MenuLeadsDirectoryIcon />,
      },
    ],
  },
  {
    id: 'LEADS-CONTACTS',
    text: 'My Leads',
    url: '/contacts',
    menuItems: [
      {
        id: 'CONTACTS',
        name: 'My Leads',
        description:
          'All of your contacts in one place. Sort, filter, and create audiences.',
        url: '/contacts',
        mustBeSysAdmin: false,
        hideFeatureFlag: 'mercury' as CompanyLevelFeatureFlag,
        icon: <MenuMyLeadsIcon />,
      },
      {
        id: 'AUDIENCES',
        name: 'Audiences',
        description: 'Subsets of your leads filtered by intent.',
        url: '/audiences',
        mustBeSysAdmin: false,
        icon: <MenuAudiencesIcon />,
      },
    ],
    hideOnMobile: false,
  },
  {
    id: 'AUTOMATIONS',
    text: 'My Automations',
    url: '/automations',
    hideOnMobile: false,
    menuItems: [
      {
        id: 'AUTOMATIONS',
        name: 'My Automations',
        description: 'Create custom outbound automations.',
        url: '/automations',
        mustBeSysAdmin: false,
        hideFeatureFlag: 'automations' as CompanyLevelFeatureFlag,
        icon: <MenuMyAutomationsIcon />,
      },
    ],
    featureFlag: 'automations' as CompanyLevelFeatureFlag,
  },
  {
    id: 'ANALYTICS',
    text: 'Analytics',
    url: '/xray-analytics',
    menuItems: [
      {
        id: 'XRAY_ANALYTICS',
        name: 'X-Ray Pixel Analytics',
        url: '/xray-analytics',
        featureFlag: 'analytics',
        mustBeSysAdmin: false,
      },
      {
        id: 'EMAIL_ANALYTICS',
        name: 'Outreach Analytics',
        url: '/outreach-analytics',
        featureFlag: 'analytics',
        mustBeSysAdmin: false,
      },
      {
        id: 'BOT_ANALYTICS',
        name: 'Bot Analytics',
        url: '/bot-analytics',
        mustBeSysAdmin: false,
      },
      {
        id: 'ADS_ANALYTICS',
        name: 'Ads Analytics',
        url: '/ads-analytics',
        featureFlag: 'analyticsAds',
        mustBeSysAdmin: false,
      },
    ],
    hideOnMobile: false,
  },
  {
    id: 'INBOX',
    text: 'Inbox',
    url: '/live-chat',
    hideOnMobile: false,
    menuItems: [],
  },
  CampaignsMenuTitle,
  {
    id: 'INTEGRATIONS',
    text: 'Integrations',
    description:
      'Connect your CRM and other platforms directly to Customers.ai',
    url: '/integrations',
    menuItems: [
      {
        id: 'INTEGRATIONS',
        name: 'Integrations',
        description:
          'Connect your CRM and other platforms directly to Customers.ai',
        url: '/integrations',
        mustBeSysAdmin: false,
        icon: <MenuIntegrationsIcon />,
      },
    ],
    hideOnMobile: false,
  },
];
